import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../images/ind-finallogo1.png";

const GlobalLoader = ({ isLoading }) => {
    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0, transition: { duration: 0.8, ease: "easeInOut" } }}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100vh",
                        backgroundColor: "#fff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999999,
                    }}
                >
                    <motion.img
                        src={logo}
                        alt="IND Matrimony"
                        initial={{ scale: 0.8, opacity: 0.5 }}
                        animate={{
                            scale: [1, 1.1, 1],
                            opacity: [0.5, 1, 0.5],
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            ease: "easeInOut",
                        }}
                        style={{ width: "150px" }} // Adjust width as needed
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default GlobalLoader;
